import { downloadUrl } from '../api';
import styles from '../styles/timeline.module.css';
import { TEXT } from '../texts';

export function FileList({ projectId, paths }: { projectId: string; paths: string[] }): React.JSX.Element {
  return (
    <div className={styles.files}>
      ✎ {TEXT.changed}{' '}
      {paths.map((path) => (
        <a key={path} href={downloadUrl(projectId, path)} download>
          {path} ↓
        </a>
      ))}
    </div>
  );
}
